// @flow
import React from 'react';
import cx from 'classnames';
import Tags from './Tags';
import styles from './styles.scss';

type Props = {
  tags: ?Array<string>,
  linkText: ?string,
  theme: string,
};

const Above = ({ tags, linkText, theme }: Props) => (
  <section id={styles.container}>
    <div className={styles.requirements}>
      <h2 className={styles.title}>条件</h2>
      <Tags tags={tags} theme={theme} />
    </div>
    <a
      href="https://www.rakuten.co.jp"
      target="_blank"
      rel="noopener noreferrer"
      className={cx(styles['note-link'], styles[theme])}
    >
      {linkText}
    </a>
  </section>
);

Above.defaultProps = {
  tags: ['ショップ対象', 'エントリーが必要'],
  linkText: '対象サービスはこちらをご確認ください',
};

export default Above;



// WEBPACK FOOTER //
// ./src/components/Above/Above.js